import * as React from 'react';

import {
  LARGE_BREAKPOINT,
  MEDIUM_BREAKPOINT,
} from '@/components/modular-grid/constants';
import { DeviceOs, DeviceType } from '@/logic/main/types';

const windowWidthDefaultDeviceMap = (width: number): DeviceType => {
  if (width < MEDIUM_BREAKPOINT.min) return 'mobile';
  else if (width < LARGE_BREAKPOINT.min) return 'tablet';
  else return 'desktop';
};

export const DeviceContext = React.createContext<{
  deviceType: DeviceType;
  deviceOs: DeviceOs;
  deviceNative: boolean;
}>({
  deviceType: windowWidthDefaultDeviceMap(window.innerWidth),
  deviceOs: null,
  deviceNative: false,
});

interface DeviceProviderPropTypes {
  children?: React.ReactNode;
  deviceType: DeviceType;
  deviceOs: DeviceOs;
  deviceNative: boolean;
  visible?: boolean;
}

const DeviceProvider: React.FC<DeviceProviderPropTypes> = ({
  children,
  visible = true,
  deviceType,
  deviceOs,
  deviceNative,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <DeviceContext.Provider value={{ deviceType, deviceOs, deviceNative }}>
      {children}
    </DeviceContext.Provider>
  );
};

export default DeviceProvider;
